import { render, staticRenderFns } from "./face-result.vue?vue&type=template&id=1b500e69&scoped=true"
import script from "./face-result.vue?vue&type=script&lang=js"
export * from "./face-result.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b500e69",
  null
  
)

export default component.exports